export const TOOL_NAME = 'pdfme (https://pdfme.com/)';
//# sourceMappingURL=constants.js.map